import { DealStatus } from '@common/model/deal/status';
import { MessageType } from '@common/model/dialog/message/messageType';
import { Stack } from '@cp/ds/src/components/stack';
import { coreDealApi } from '@cp/entities/deal';
import { DialogMessageRenderer, coreDialogApi } from '@cp/entities/dialog';
import { FC, lazy, useEffect } from 'react';
import { useClientProfile } from 'src/entities/client';
import { DealMessage } from 'src/features/dialog/deal';

const messageWidgets: Record<DealStatus, FC<DealMessage> | null> = {
  [DealStatus.Negotiation]: lazy(() => import('src/features/dialog/deal').then((module) => ({ default: module.MessageNegotionation }))),
  [DealStatus.Accepted]: lazy(() => import('src/features/dialog/deal').then((module) => ({ default: module.MessageAccepted }))),
  [DealStatus.Completed]: lazy(() => import('src/features/dialog/deal').then((module) => ({ default: module.MessageCompleted }))),
  [DealStatus.InProgress]: lazy(() => import('src/features/dialog/deal').then((module) => ({ default: module.MessageAccepted }))),
  [DealStatus.Rejected]: lazy(() => import('src/features/dialog/deal').then((module) => ({ default: module.MessageRejected }))),
};

export const DealProposition: DialogMessageRenderer<MessageType.DealProposition> = (props) => {
  const clientProfile = useClientProfile();
  const { isLoading, data: deal, refetch } = coreDealApi.endpoints.getOne.useQuery({ dealId: props.message.payload.dealId });
  const MessageWidget = messageWidgets[props.message.payload.dealStatus];
  const isMessageAuthor = props.message.author.entityId === clientProfile?.id;
  const [markMessageRead] = coreDialogApi.useMarkReadMutation();

  useEffect(() => {
    refetch();
  }, [props.message.payload.dealStatus, refetch]);

  useEffect(() => {
    if (!deal || deal.status === props.message.payload.dealStatus) {
      return;
    }
    markMessageRead({ dialogId: +props.dialogId, messageId: props.message.id });
  }, [deal, markMessageRead, props.dialogId, props.message.id, props.message.payload.dealStatus]);

  if (!deal || isLoading || !MessageWidget) {
    return null;
  }

  if (deal.status !== props.message.payload.dealStatus && isMessageAuthor) {
    return null;
  }

  const disableWidget = props.isPreview || deal.status !== props.message.payload.dealStatus;

  return (
    <Stack alignItems={isMessageAuthor || props.isPreview ? 'flex-end' : 'flex-start'} sx={{ pr: props.isPreview ? 1 : 0 }}>
      <MessageWidget deal={deal} disableWidget={disableWidget} message={props.message} />
    </Stack>
  );
};
